import {Icon} from '@wandb/weave/components/Icon';
import * as React from 'react';
import {useEffect} from 'react';
import {twMerge} from 'tailwind-merge';

import {UNAVAILBALE_WORKSPACES_ERROR} from '../../state/workspaces/namedWorkspaceUrls';
import {useTrackWorkspaceError} from './utils';
import {WorkspaceEmptyContent} from './WorkspaceEmptyContent';
import {
  WorkspaceError,
  type WorkspaceErrorContentProps,
} from './WorkspaceError';

export const WorkspaceErrorContent = (props: WorkspaceErrorContentProps) => {
  if (props.error?.userTitle === UNAVAILBALE_WORKSPACES_ERROR.userTitle) {
    return <WorkspaceEmptyContent {...props} />;
  }

  return <WorkspaceGenericErrorContent {...props} />;
};

const WorkspaceGenericErrorContent = ({
  error,
  viewType,
}: WorkspaceErrorContentProps) => {
  const trackWorkspaceError = useTrackWorkspaceError({
    action: 'View',
    errorType: 'Generic',
    viewType,
  });

  useEffect(() => {
    trackWorkspaceError(error);
  }, [error, trackWorkspaceError]);

  return (
    <WorkspaceError
      title={error?.userTitle ?? 'Something went wrong'}
      header={
        <div
          className={twMerge(
            'mb-16 h-[80px] w-[80px] shrink-0 rounded-full',
            'bg-moon-550/[.1] text-wb-text-tertiary',
            'flex items-center justify-center'
          )}>
          <Icon name="warning" width={34} height={34} />
        </div>
      }>
      <div className="text-wrap mt-4 w-[600px] text-center text-lg leading-[140%]">
        <p>
          {error?.userMessage
            ? error?.userMessage
            : 'An unexpected error occurred.'}
        </p>
        <p>
          Please contact{' '}
          <a
            className="font-semibold hover:text-wb-text-link-hover"
            href="mailto:support@wandb.com"
            rel="noopener noreferrer">
            support@wandb.com
          </a>{' '}
          for help.
        </p>
      </div>
    </WorkspaceError>
  );
};
